import { api } from './index';

const NotificationRequestService = {
  notification(params) {
    return api.get('notification', params);
  },
  getNotViewed() {
    return api.get('notification-count');
  },
  setRead(id) {
    return api.put(`notification-set-read/${id}`);
  },
  setReadAll(id) {
    return api.get(`all-notifications-set-read/${id}`);
  },
  setViewed(params) {
    return api.put(`notification-set-viewed/`, params);
  },
  save(params) {
    return api.post('notification/save', params)
  },
  delete(id) {
    return api.delete(`notification/${id}/delete`)
  }
};

export default NotificationRequestService;